export function trimTrailingSlash (url) {
  return url.replace(/\/$/, '')
}
